<template>
  <div class="preview-container" v-if="visible">
    <div class="preview">
      <img class="preview-img" :src="url">
      <i class="box center icon-close el-icon-error"  @click="onClosePreview" title="关闭预览" ></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Preview',
  props: {
    url: {
      type: String
    },
    type: {
      type: String,
      default: 'image'
    }
  },
  data () {
    return {
      visible: true
    }
  },
  mounted () {
    console.log(this.url, 'url ##>>')
  },
  methods: {
    onClosePreview () {
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
.preview-container {
    position: fixed;
    left: 0;
    top: 0;
    width: calc(100%);
    height: calc(100%);
    background: rgba(0, 0, 0, 0.3);
    z-index: 10000;
    display: flex;
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
    .box {
        display: flex;
        box-sizing: border-box;
    }
    .center {
        justify-content: center;
        align-items: center;
    }
    .preview {
        position: relative;

        &-img,
        &-video {
            border: 2px solid white;
            max-width: calc(80vw);
            max-height: calc(80vh);
        }
        .icon-close {
            position: absolute;
            right: -40px;
            top: -26px;
            color: white;
            font-size: 26px;
            cursor: pointer;
            z-index: 99;

            &::after {
                content: '';
                display: inline-block;
                width: 70%;
                height: 70%;
                border-radius: 50%;
                background: black;
                position: absolute;
                left: 4px;
                top: 4px;
                z-index: -1;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/webpc/Preview/template.vue